export enum EIDENTIFIERS {
  WelCome = 'WelCome',
  ActionPanel = 'ActionPanel',
  SideBar = 'SideBar',
  Settings = 'Settings',
  Main = 'Main',
  Explorer = 'Explorer',
  Header = 'Header',
  ComponentList = 'ComponentList',
}
